<div class="flex h-full min-h-0 w-full flex-col overflow-y-auto scrollbar-transparent">
  <div class="flex min-h-0 flex-1 flex-col p-4">
    <section class="rounded-xl border border-zinc-200 p-4 dark:border-zinc-800">
      <h4 class="text-sm font-semibold text-primary m-0">Create voucher</h4>
      <p class="mt-1 text-xs text-secondary m-0">
        One named code, any brand can redeem it once. Credits the selected currency.
      </p>

      <form class="mt-4 flex flex-col gap-4" [formGroup]="form" (ngSubmit)="submit()">
        <label class="flex flex-col gap-1" for="admin-voucher-name">
          <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">Name</span>
          <input id="admin-voucher-name" type="text" formControlName="name" class="input-primary" autocomplete="off" />
        </label>
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <label class="flex flex-col gap-1" for="admin-voucher-amount">
            <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">Amount</span>
            <div class="flex">
              <div
                class="flex min-w-12 shrink-0 items-center justify-center rounded-l-md bg-white/50 px-3 text-base text-gray-400 outline outline-1 -outline-offset-1 outline-zinc-300 dark:bg-white/5 dark:outline-white/10 sm:text-sm/6"
                aria-hidden="true">
                <p class="m-0">{{ currencySymbol() }}</p>
              </div>
              <input id="admin-voucher-amount" type="number" min="0.01" step="0.01" formControlName="amount"
                placeholder="0.00"
                class="-ml-px min-w-0 grow bg-[var(--input)] px-3 py-1.5 text-base text-primary outline outline-1 -outline-offset-1 outline-zinc-300 placeholder:text-secondary focus:z-10 focus:outline-2 focus:outline-offset-2 focus:outline-[var(--ring)] dark:outline-white/10 sm:text-sm/6" />
            </div>
          </label>
          <div class="flex flex-col gap-1">
            <label for="admin-voucher-currency" class="text-xs font-semibold uppercase tracking-wide text-slate-500">Currency</label>
            <el-select id="admin-voucher-currency" name="currencyCode" class="block w-full"
              [value]="form.controls.currencyCode.value">
              <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
                <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-2 truncate pr-6">
                  @if (selectedCurrencyOption(); as currency) {
                    <img [src]="currency.flagUrl" [alt]="currency.label"
                      class="h-4 w-6 shrink-0 rounded-sm object-cover" />
                    <p class="m-0 truncate">{{ currency.label }}</p>
                  } @else {
                    <p class="m-0 truncate text-secondary">Select currency</p>
                  }
                </el-selectedcontent>
                <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                  class="col-start-1 row-start-1 size-5 self-center justify-self-end text-secondary sm:size-4">
                  <path
                    d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                    clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
              </button>
              <el-options anchor="bottom start" popover class="dropdown-select-primary-menu">
                @for (currency of currencyOptions; track currency.value) {
                  <el-option [value]="currency.value" (click)="onCurrencySelected(currency.value)"
                    class="group/option relative block cursor-pointer py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
                    <div class="flex items-center gap-2">
                      <img [src]="currency.flagUrl" [alt]="currency.label"
                        class="h-4 w-6 shrink-0 rounded-sm object-cover" />
                      <p class="m-0 truncate font-normal group-aria-selected/option:font-semibold">{{ currency.label }}</p>
                    </div>
                    <span
                      class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-not-aria-selected/option:hidden group-focus/option:text-primary-foreground in-[el-selectedcontent]:hidden">
                      <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                        <path
                          d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                          clip-rule="evenodd" fill-rule="evenodd" />
                      </svg>
                    </span>
                  </el-option>
                }
              </el-options>
            </el-select>
          </div>
          <label class="flex flex-col gap-1" for="admin-voucher-expires">
            <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">Expires</span>
            <input id="admin-voucher-expires" type="date" formControlName="expiresAt" class="input-primary" />
          </label>
        </div>
        <button type="submit" class="btn-shout btn-shout-sm btn-shout-primary self-start" [disabled]="submitting()">
          {{ submitting() ? 'Creating…' : 'Create voucher' }}
        </button>
      </form>
    </section>
  </div>
</div>
